import { deepGet } from '../api/Utils';

export function useLegendGraphic(
  dataMetricsGraphic: Array<Object>,
  xAxisLocation: Array<String>,
  valuesKeyMetrics: Object,
  schemaGraphic: Object,
  checked?: string
) {
  const colors: Object = {
    totalStrength: '#84C0C1',
    internalRotation: '#007AFF',
    externalRotation: '#00C8FF',
    scaption: '#F200FF',
    grip: '#FD8B12',
    erIrRatio: '#84C0C1',
    svr: '#84C0C1',
    freshTotalRatio: '#84C0C1',
    freshIRRatio: '#007AFF',
    freshERRatio: '#00C8FF',
    freshScaptionRatio: '#F200FF',
    freshGripRatio: '#FD8B12',
    velocity: '#84C0C1',
  };

  let schemaTrace: Object = {
    x: [],
    y: [],
    id: '',
    name: '',
    text: [],
    checked: true,
    type: 'scatter',
    color: '',
    legendColor: '',
    hovertemplate:
      "<b>%{text}</b><br>" +
      "(%{x}, %{y})<br>" +
      "<extra></extra>",
    marker: {
      color: '',
      size: 20,
      line: {
        color: 'white',
        width: 3,
      },
    },
    line: {
      width: 4,
    },
  };

  const names: Object = {
    totalStrength: 'Total Strength',
    internalRotation: 'IR',
    externalRotation: 'ER',
    scaption: 'Scaption',
    grip: 'Grip',
    erIrRatio: 'shoulder Balance',
    svr: 'strength Velocity Ratio',
    freshTotalRatio: 'Total Strength',
    freshIRRatio: 'IR',
    freshERRatio: 'ER',
    freshScaptionRatio: 'Scaption',
    freshGripRatio: 'Grip',
    velocity: 'Max Velocity',
  };

  let metricsGraphic = JSON.parse(JSON.stringify(schemaGraphic));

  dataMetricsGraphic.forEach(item => {
    Object.keys(valuesKeyMetrics).forEach((metric) => {
      metricsGraphic[metric]['yAxisLabel'] = valuesKeyMetrics[metric][['yAxisLabel']];
      valuesKeyMetrics[metric].values.forEach(key => {
        if (!metricsGraphic[metric]['metrics'][key]) metricsGraphic[metric]['metrics'][key] = { ...schemaTrace };
        if (checked) {
          if (metric === checked) metricsGraphic[metric]['checked'] = true
          else metricsGraphic[metric]['checked'] = false
        }        
        metricsGraphic[metric]['metrics'][key]['marker'].color = colors[key];
        metricsGraphic[metric]['metrics'][key]['color'] = colors[key];
        metricsGraphic[metric]['metrics'][key]['legendColor'] = colors[key];
        metricsGraphic[metric]['metrics'][key]['name'] = key;
        metricsGraphic[metric]['metrics'][key]['id'] = `${metric}-${key}`;
        metricsGraphic[metric]['metrics'][key]['marker'] = { ...metricsGraphic[metric]['metrics'][key]['marker'] };
        //If the exams has metrics, the metric is added to the graph.                        
        if (item[metric][key]) {
          let xAxis: Array<String> = metricsGraphic[metric]['metrics'][key]['x'].slice();
          let yAxis: Array<Number> = metricsGraphic[metric]['metrics'][key]['y'].slice();
          let text: Array<String> = metricsGraphic[metric]['metrics'][key]['text'].slice();

          text.push(names[key])
          xAxis.push(deepGet(item, [...xAxisLocation]));
          //only the integer part should be taken for the arm force graph
          if (metric === 'armStrength') {
            yAxis.push(Math.trunc(item[metric][key]))
          } else {
            yAxis.push(item[metric][key])
          }

          metricsGraphic[metric]['metrics'][key]['x'] = xAxis;
          metricsGraphic[metric]['metrics'][key]['y'] = yAxis;
          metricsGraphic[metric]['metrics'][key]['text'] = text;
        }
      })
    })
  })

  return metricsGraphic;
}